import ImageElement from './ImageElement'
import { elementType } from '../vars'

export default class Zone extends ImageElement {
  get suffix() {
    return this.zone
  }

  get type() {
    return elementType.Zone
  }

  get name() {
    return `${this.type}${this.suffix}`
  }

  get alt() {
    return `${this.capitalize(this.type)} ${this.suffix}`
  }

  get isDraggable() {
    return false
  }

  get isActionable() {
    return false // true
  }

  get isZoneElement() {
    return true
  }

  /* onMouseOver() {
    this.data.onMouseOverAction()
  }

  onMouseOut() {
    this.data.onMouseOutAction()
  } */

  draw(ctx) {
    // Save current context settings
    ctx.save()
    // const y = this.scale.x(this.cell[0])
    const y = this.scale.y(this.cell[0])
    const x = this.scale.x(this.cell[1])
    // Get center of image for shifting/rotating
    const dx = x + this.radius
    const dy = y + this.radius
    // ctx.translate(dx, dy)
    // ctx.rotate(this.angle * (Math.PI / 180))
    // ctx.translate(-dx, -dy)
    // parts of our board are always rendering at 100x100, so we need to account for that manually
    // TODO: have that value be set in a config and reference the config here instead
    ctx.drawImage(this.image, x + (50 - this.width / 2), y + (50 - this.height / 2), this.width, this.height)
    // Restore previous context settings
    ctx.restore()
  }
}
